import { createFileRoute } from "@tanstack/react-router";
import { SignalsWorkspace } from "@/components/AdditionalWorkspaces";

export const Route = createFileRoute("/signals")({ component: SignalsWorkspace });
